export default {
  citiesWithoutAddressValidation: [39],
  nonCashResources: {
    1: {title: 'coincat'},
    2: {title: 'streampay'},
    3: {title: 'сбер', 'useCards': true},
  },
  operationCurrency: {id: 33, title: 'RUB'},
  allowSalaryCurrencies: {
    33: {id: 33, title: 'RUB'},
    40: {id: 40, title: 'KZT'},
  },
  orderRejectReasons: [
    {id: 1, title: 'Нужно срочно'},
    {id: 6, title: 'Нет в наличии'},
    {id: 2, title: 'Нашли дешевле'},
    {id: 3, title: 'Нужны документы'},
    {id: 4, title: 'Нет доставки'},
    {id: 5, title: 'Дубль'},
    {id: 7, title: 'Консультация'},
    {id: 8, title: 'Уже купили'},
    {id: 9, title: 'Недозвон'},
    {id: 10, title: 'Не хочет предоплаты'},
    {id: 11, title: 'Закажет курьером'},
    {id: 12, title: 'Забрать с аптеки'},
    {id: 0, title: 'Свой вариант'},
  ],
  salaryRateTitles: {
    0: 'Низкая ставка',
    1: 'Высокая ставка',
    2: 'Дальная область',
    3: 'Индивидуальная',
    999: 'Персональный просчет'
  },
  customerRequestStatuses:
    [
      {id: 1, title: 'Нет в наличии'},
      {id: 2, title: 'Нет перепарата в системе'},
      {id: 3, title: 'Дорого/Нашли дешевле'},
      {id: 4, title: 'Срочно/Не хочет ждать'},
      {id: 5, title: 'Нет логистики по адресу'},
      {id: 6, title: 'Консультация'},
      {id: 7, title: 'Повторное обращение (спрос/дубль)'},
      {id: 8, title: 'Метод оплаты'},
      {id: 9, title: 'Чек/Сертификаты/Документы'},
      {id: 10, title: 'Не устраивает метод оплаты'},
      {id: 11, title: 'Не клиент'},
    ],
  salaryRates: {
    0: 'Низкая ставка',
    1: 'Высокая ставка',
    2: 'Дальная область',
    3: 'Индивидуальная',
  },
  cashOutTypes: {
    0: {title: 'Не указан', alias: 'none'},
    1: {title: 'Мск', alias: 'cash_to_msk'},
    2: {title: 'Тезер', alias: 'TRC'},
    3: {title: 'СПБ+АЛА', alias: 'cash_to_msk'},
    4: {title: 'Наличные', alias: 'cash'},
  },
  clonePrices: {
    12: [13],
    1: [4]
  },
  supplierDeliveryExpensesTypes: {
    byVolume: {title: 'По объему', alias: 'byVolume'},
    byWeight: {title: 'По весу', alias: 'byWeight'},
    byItem: {title: 'По упаковкам', alias: 'byItem'},
    percentByPrice: {title: '% от стоимости', alias: 'percentByPrice'},
  }
}
